<template>
  <li class="file">
    <!-- Attachment name and errors -->
    <div class="f-center">
      <img @click="showBigImage" :src="require(`@/assets/${type}_150.webp`)"
           class="illustration-picture mr-1-768 hide-768 mr-3" alt="">
      <h4 class="font-small file-name font-dark">
        <slot></slot>
      </h4>
    </div>

    <!-- Attachment size anc action buttons -->
    <div class="f-center f-column-480 align-items-start-480 justify-content-start-480">
      <strong class="mr-3 file__size mr-1-768 pl-3 pl-0-480 mr-0-480">
        Max. {{ MAX_SIZE_OF_ATTACHMENT  | fileSizeFormat}}
        <span v-if="filesCount">({{ filesCount > 1 ? "max " : "" }}{{ filesCount }}ks)</span>
      </strong>
    </div>
  </li>
</template>

<script>
import { MAX_SIZE_OF_ATTACHMENT } from '@/config';

export default {
  data() {
    return { MAX_SIZE_OF_ATTACHMENT };
  },
  name: 'SummaryFileItem',
  props: {
    filesCount: { required: false, type: Number, default: () => 1 },
    type: { required: true, type: String },
  },
  methods: {
    showBigImage() {
      this.$store.commit('SET_ILLUSTRATIONPREVIEW_TYPE', this.type);
      this.$store.commit('SET_ILLUSTRATIONPREVIEW', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~union_styles/scss/variables";
@import "~union_styles/scss/helpers/mixins/flexbox";
@import "~union_styles/scss/helpers/mixins/position";

.illustration-picture {
  cursor: pointer;
  max-height: 50px;
  max-width: 75px;
}

.file-name {
  word-break: break-all;
}

.icon {
  &--attachment-green, &--attachment-orange {
    min-width: 47.7px;
  }
}

.upload-btn {
  padding: 12px 48px;
  border-radius: 8px;
  background-color: $color-primary;
  color: $color-light;
}

.upload-info {
  max-width: 350px;
  text-align: center;
}

.file-group {
  list-style-type: none;
  width: 100%;
  margin-bottom: 30px;
}

.file {
  $file_self: &;
  @include f-vertical-center();
  background-color: $color-light;
  justify-content: space-between;
  padding: 18px 36px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  margin-bottom: 20px;
  border: 1px solid $border-color-primary;

  &:last-child {
    margin-bottom: 0;
  }

  &__size {
    white-space: nowrap;
  }

  &__error {
    margin-top: 3px;
    display: none;
  }

  &__upload-remove {
    display: none;
    border: 1px solid $border-color-primary;
    padding: 4px 12px;
    font-size: 13px;
    min-height: unset;
    border-radius: 6px;
    margin-left: 46.6px;
    margin-top: 10px;
    @media (max-width: 480px) {
      display: block;
    }
  }

  &--invalid {
    border-color: $color-warning;

    #{$file_self}__size {
      color: $color-warning;
    }

    #{$file_self}__error {
      display: block;
    }
  }

  @media (max-width: 480px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 12px 22px;
    margin-bottom: 10px;

    &__size {
      font-size: 14px;
      font-weight: 400;
    }

    .file-name {
      font-size: 16px;
    }
  }
}

.hover {
  border-style: solid;
  border-color: $color-primary;
  background-color: rgba($color-primary, 0.02);
}

.invalid {
  .snack-bar.orange {
    display: flex !important;
  }

  border-color: $color-warning !important;
  border-style: solid;
}

@media (max-width: 768px) {
  padding: 0;
  border: none !important;

  &__upload-btn {
    align-self: flex-start;
  }
  &__upload-info {
    align-self: flex-start;
    text-align: left
  }

  &__file {
    padding: 12px 22px;
  }

  .icon {
    &--attachment-green, &--attachment-orange {
      height: 40px;
      width: 36.6px;
      min-width: 36.6px;
    }
  }
}

@media (max-width: 480px) {
  &__file {
    align-items: flex-start;
    flex-direction: column;

    &__size {
      padding-top: 5px;
      padding-left: 46.6px;
    }

    .icon.icon--cross-gray {
      display: none;
    }
  }
}
</style>
